import * as toastr from 'toastr';

toastr.options.closeButton = true;
toastr.options.showEasing = null;
toastr.options.hideEasing = null;
toastr.options.closeEasing = null;

export const toastError = (errorMsg = '') => {
  const msg = typeof errorMsg === 'string' ? errorMsg : 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie';
  toastr.error(msg);
};

export const toastSuccess = (msg = '') => {
  toastr.success(msg);
};

export const listMixin = {
  data: function () {
    return {
      paramsName: '',
      totalCount: 0,
    };
  },
  methods: {
    setOrderBy: function (orderBy) {
      if (orderBy !== this.$store.state[this.paramsName].orderBy) {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: { orderBy },
        });
      } else {
        const sortOrder = this.$store.state[this.paramsName].sortOrder === 'asc' ? 'desc' : 'asc';
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: { sortOrder },
        });
      }
      this.loadItems();
    },
    toggleFiltersVisibility: function () {
      this.filtersVisible = !this.filtersVisible;
      this.$store.commit('setParams', {
        paramsName: [this.paramsName],
        params: { filtersVisible: this.filtersVisible },
      });
    },
    loadItems: function () {
      // mock to be overwritten in component
    },
  }
};